import base_actions from '@/store/modules/base/actions'

export default {
    ...base_actions,
}